var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNenhumafechadura(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 417.6 643.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #94d8f4;\n        stroke-width: 9.2px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke: #2d2165;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 4.6px;\n      }\n\n      .cls-5 {\n        fill: #6543fa;\n      }\n\n      .cls-3, .cls-6 {\n        fill: #2d2165;\n      }\n\n      .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-8 {\n        fill: #7041ff;\n      }\n\n      .cls-9, .cls-4 {\n        fill: #fcfdfd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 295.88,
    cy: 605.12,
    rx: 121.71,
    ry: 38.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.71,422.3l43.45,71.1c11.43,18.71,29.26,32.64,50.18,39.22h0l29.29,66.28c6.92,15.66,22.43,25.76,39.54,25.76h58.98l-21.21-254.26-112.17-33.37-88.07,85.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.68,217.43L24.37,114.87c-10.01-6.92-23.5,1.28-21.95,13.36h0c.4,3.14,1.85,6.05,4.11,8.26l130,127.29,36.15-46.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.68,274.9L24.37,172.35c-10.01-6.92-23.5,1.28-21.95,13.36h0c.4,3.14,1.85,6.05,4.11,8.26l130,127.29,36.15-46.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 55.36,
    y: 86.19,
    width: 199.05,
    height: 412.12,
    rx: 16.88,
    ry: 16.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 48.87,
    y: 86.19,
    width: 199.05,
    height: 412.12,
    rx: 16.88,
    ry: 16.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M46.17,256.83l-31.34,16.3c-8.01,4.17-10.63,14.37-5.63,21.88l46.24,69.35h0c8.08-13.85,8.48-30.87,1.06-45.08l-10.33-19.81v-42.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.47,320.28l-10.24,6.38c-6.67,4.16-8.26,13.19-3.4,19.37l44.83,57.07h0c6.07-12.57,5.27-27.37-2.13-39.21l-10.31-16.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.2,295.01l46.24,69.35h0c8.08-13.85,8.48-30.87,1.06-45.08l-10.33-19.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.65,403.11h0c6.07-12.57,5.27-27.37-2.13-39.21l-10.31-16.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.78,534.47l-5.86-8.75c-41.45-61.91-45.26-141.66-9.9-207.24h0v-79.15c0-8.64,4.69-20.94,8.8-30.04,2.04-4.52,8.58-4.14,10.06.6l31.42,100.15c6,19.14,9.35,39.01,9.96,59.06l4.66,155.18,31.31,69.28c-1.53,27.53-73.22,31.35-73.22,31.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.78,534.47l-5.86-8.75c-41.45-61.91-45.26-141.66-9.9-207.24h0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M148.4,293.63c-17.96,0-32.57-15.52-32.57-34.6s14.61-34.6,32.57-34.6,32.57,15.52,32.57,34.6-14.61,34.6-32.57,34.6ZM148.4,233.17c-13.14,0-23.83,11.6-23.83,25.86s10.69,25.86,23.83,25.86,23.83-11.6,23.83-25.86-10.69-25.86-23.83-25.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M179.24,353.93h-61.69c-11.33-.01-20.51-9.19-20.52-20.52v-60.51c0-7.75,6.29-14.04,14.05-14.05h74.63c7.75,0,14.04,6.29,14.05,14.05v60.51c-.01,11.33-9.19,20.51-20.52,20.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.42,297.66c0-6.64-5.37-12.03-12.01-12.03-6.64,0-12.03,5.37-12.03,12.01,0,4.52,2.53,8.66,6.56,10.72v18.81h10.93v-18.81c4.02-2.05,6.56-6.18,6.56-10.7Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 246.86,
    cy: 101.86,
    r: 101.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M267.81,75.93l-19.73,15.58-15.58-19.73c-2.52-3.19-7.15-3.74-10.35-1.22-3.19,2.52-3.74,7.15-1.22,10.35l15.58,19.73-19.73,15.58c-3.19,2.52-3.73,7.16-1.21,10.35,2.52,3.19,7.15,3.73,10.34,1.22l19.73-15.58,15.58,19.73c2.52,3.19,7.16,3.73,10.35,1.21,3.19-2.52,3.73-7.15,1.22-10.34l-15.58-19.73,19.73-15.58c3.19-2.52,3.74-7.15,1.22-10.35-2.52-3.19-7.15-3.74-10.35-1.22h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.1,447.58h2.35l1.68,6.2,1.83-6.07h2.02l1.82,6.07,1.69-6.2h2.35l-2.51,8.52h-2.83l-1.53-5.17-1.53,5.17h-2.83l-2.51-8.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M130.45,451.84c0-2.6,1.86-4.43,4.38-4.43,2.34,0,4.13,1.57,4.13,4.15,0,.31-.03.63-.08.97h-6.16c.17,1,1.19,1.7,2.27,1.7.84,0,1.57-.39,2.12-1.2l1.62,1.21c-.8,1.33-2.29,2.05-3.79,2.05-2.73,0-4.49-1.97-4.49-4.46ZM136.84,451c-.12-.95-.9-1.68-1.98-1.68s-1.98.71-2.1,1.68h4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M139.75,456.1v-12.5h2.24v5.01c.56-.71,1.44-1.21,2.8-1.21,2.41,0,4.13,1.84,4.13,4.43s-1.71,4.45-4.13,4.45c-1.25,0-2.22-.43-2.77-1.08l-.04.91h-2.23ZM144.33,454.24c1.35,0,2.31-1.07,2.31-2.41s-.95-2.38-2.31-2.38-2.32,1.02-2.32,2.38.97,2.41,2.32,2.41Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M149.51,451.83c0-2.49,2.01-4.45,4.54-4.45,1.6,0,3.18.83,3.96,2.43l-1.73,1.1c-.5-.99-1.37-1.44-2.19-1.44-1.37,0-2.32,1.05-2.32,2.4s.98,2.35,2.28,2.35c.92,0,1.7-.43,2.27-1.47l1.64,1.15c-.78,1.55-2.37,2.38-3.97,2.38-2.56,0-4.49-1.97-4.49-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M158.55,456.1v-12.5h2.28v4.88c.44-.54,1.33-1.08,2.56-1.08,1.95,0,3.35,1.3,3.35,3.35v5.35h-2.28v-4.77c0-1.18-.75-1.82-1.74-1.82s-1.88.64-1.88,1.82v4.77h-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.37,451.84c0-2.6,1.86-4.43,4.38-4.43,2.34,0,4.13,1.57,4.13,4.15,0,.31-.03.63-.08.97h-6.16c.17,1,1.19,1.7,2.27,1.7.84,0,1.57-.39,2.12-1.2l1.62,1.21c-.8,1.33-2.29,2.05-3.79,2.05-2.73,0-4.49-1.97-4.49-4.46ZM173.76,451c-.12-.95-.9-1.68-1.98-1.68s-1.98.71-2.1,1.68h4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M176.1,451.83c0-2.49,2.01-4.45,4.54-4.45,1.6,0,3.18.83,3.96,2.43l-1.73,1.1c-.5-.99-1.37-1.44-2.19-1.44-1.37,0-2.32,1.05-2.32,2.4s.98,2.35,2.28,2.35c.92,0,1.7-.43,2.27-1.47l1.64,1.15c-.78,1.55-2.37,2.38-3.97,2.38-2.56,0-4.49-1.97-4.49-4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M195.9,443.54c.77,0,1.31.53,1.31,1.31s-.54,1.3-1.31,1.3-1.3-.53-1.3-1.3.53-1.31,1.3-1.31ZM194.77,456.1v-8.52h2.28v8.52h-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M198.36,456.1v-8.52h2.17l.04.99c.44-.59,1.36-1.16,2.63-1.16,1.97,0,3.36,1.3,3.36,3.35v5.35h-2.27v-4.77c0-1.18-.76-1.82-1.77-1.82s-1.89.64-1.89,1.82v4.77h-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M188.75,452.96c-.51.09-1.02.15-1.58.18v2.96h-2.31v-13.09h2.31v5.47c1.13-1.15,2.58-1.87,4.02-1.87,1.71,0,2.84,1,2.84,2.49s-1.09,2.58-3.04,3.29l-2.24.56ZM187.17,451.45c2.98-.29,4.78-1.09,4.78-2.13,0-.51-.44-.84-1.15-.84-1.18,0-2.69.85-3.64,2.11v.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M190.07,451.21l3.81,4.88h-2.81l-2.52-3.41"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.17,454.96c-.88,0-1.7-.34-2.32-.96l-1.84-1.84,2.03-2.03,1.84,1.84c.1.1.21.12.28.12s.19-.02.28-.12l4.22-4.22,2.03,2.03-4.22,4.22c-.62.62-1.44.96-2.32.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M107.82,459.73h-13.22c-2.41,0-4.37-1.96-4.37-4.37v-5.4c0-1.17.45-2.26,1.28-3.09l6.61-6.61c.82-.82,1.92-1.28,3.09-1.28s2.26.45,3.09,1.28l6.61,6.61c.82.82,1.28,1.92,1.28,3.09v5.4c0,2.41-1.96,4.37-4.37,4.37ZM101.21,441.87c-.4,0-.77.15-1.05.44l-6.61,6.61c-.28.28-.44.65-.44,1.05v5.4c0,.82.67,1.49,1.49,1.49h13.22c.82,0,1.49-.67,1.49-1.49v-5.4c0-.4-.15-.77-.44-1.05l-6.61-6.61c-.28-.28-.66-.44-1.05-.44Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNenhumafechadura);
export default __webpack_public_path__ + "static/media/Nenhuma fechadura.67bf2332d87897fcae8a8e2a43d0c05f.svg";
export { ForwardRef as ReactComponent };